// Convert an object of `*Accessor`-style prop names to the
// `[{ accessor, label }]` shape `useReportComponentAccessors` expects.
// Caller decides which props go in (per-row column paths only); the row-array
// path itself is passed separately as `dataAccessor` to the hook.
export function buildPropAccessors (perRowProps) {
  const out = []
  for (const [key, value] of Object.entries(perRowProps || {})) {
    const baseLabel = key.endsWith('Accessor') ? key.slice(0, -'Accessor'.length) : key
    if (typeof value === 'string' && value) {
      out.push({ accessor: value, label: baseLabel })
      continue
    }
    if (Array.isArray(value)) {
      value.forEach((v, i) => {
        if (typeof v === 'string' && v) {
          out.push({
            accessor: v,
            label: value.length > 1 ? `${baseLabel}[${i}]` : baseLabel
          })
        }
      })
    }
  }
  return out
}
